// React
import React, { SyntheticEvent } from 'react'

// Style
import { Form } from 'semantic-ui-react'
import type { DropdownProps } from 'semantic-ui-react'

// Models
import { HUMAN_FORMAT } from 'types/deck'

// Utils
import { humanReadableObjectToDropdown } from 'utils/DropdownConversions'

type Props = {
  value: Array<string | number> | string | number
  onChange: (e: SyntheticEvent<HTMLElement, Event>, change: DropdownProps) => void
  placeholder?: string
}

/**
 * Allows the selection of formats for the deck search. Uses a passed in handleChange function and passed in value.
 */
const FormatDropdown = ({ value, placeholder, onChange }: Props) => {
  const options = humanReadableObjectToDropdown(HUMAN_FORMAT)

  return (
    <Form.Select
      placeholder={placeholder || 'Formats'}
      name="formats"
      fluid
      search
      selection
      multiple={Array.isArray(value)}
      options={options}
      onChange={onChange}
      value={value}
    />
  )
}

export default FormatDropdown
